import {useNavigate} from "react-router-dom";
import {url} from "../../utils/urls";
import {isNotEmpty} from "../../utils/strings";
import {stopEvent} from "../../utils/events";
import {img} from "../../utils/image";

const ULMenuList = (
  {
    ulClassName = "",
    titleClassname = "menu-title",
    title = "",
    outerTitle = "",
    menus = [],
    idPrefix = "",
    style = {},
    fontColor = "",
    titleFontColor = "",
  }) => {
  const navigate = useNavigate();

  const handleClick = (e, path) => {
    stopEvent(e);
    navigate(path, {state: {ok: true}});
  }

  return (
    (menus && menus.length > 0) ?
      (
    <>
      {isNotEmpty(outerTitle) &&
        <p className={titleClassname} style={{color: titleFontColor}}>{outerTitle}</p>
      }
      <ul className={ulClassName} style={style}>
        {isNotEmpty(title) &&
          <li className={titleClassname} style={{color: titleFontColor}}>{title}</li>
        }
        {menus.map((menu) =>
          <li key={idPrefix + menu.id}
              style={menu.style}
              data-id={idPrefix + menu.id}
              className={menu.attr.className}
          >
            <a href={url(menu.attr.href)}
               className={"d-flex align-items-center justify-content-center gap-2 h-100"}
               style={isNotEmpty(fontColor) ? {color: fontColor} : {}}
               onClick={(e) => {
                 handleClick(e, url(menu.attr.href))
               }}>
              {isNotEmpty(menu.attr.src) &&
                <img src={img(menu.attr.src)}/>
              }
              {isNotEmpty(menu.innerText) &&
                <span>{menu.innerText}</span>
              }
            </a>
          </li>
        )}
      </ul>
    </>
      ) : (
        <></>
      )
  )
};
export default ULMenuList;